/*
 * -----------------------------------------------------------------------
 *  <copyright file="reporting-signalr-service.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { HttpTransportType, HubConnectionBuilder, HubConnectionState, JsonHubProtocol } from '@microsoft/signalr';

import Settings from 'settings/settings';
import { Logger } from '@utils/logger';

const reportingConnection = new HubConnectionBuilder()
    .withUrl(`${Settings.api.reportingHubUrl()}/reportinghub`, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .withHubProtocol(new JsonHubProtocol())
    .build();

const connectToReportingServer = (user: any) => {
    const userId = user.id;

    if (reportingConnection.state !== HubConnectionState.Connected) {
        reportingConnection
            .start()
            .then(() => {
                reportingConnection.invoke('RegisterUser', userId);
            })
            .then(() => {
                Logger.log('Joined user to reporting service hub: ', userId);
            })
            .catch((ex: any) => {
                console.log('Error reporting service connecting', ex);
            });
    } else {
        reportingConnection
            .invoke('RegisterUser', userId)
            .then(() => {
                Logger.log('Joined user to reporting service hub: ', userId);
            })
            .catch((ex: any) => {
                console.log('Error reporting service connecting', ex);
            });
    }
};

export { connectToReportingServer, reportingConnection };
